<template>
  <v-app-bar
    :color="background"
    dark
    height="auto"
    :style="$vuetify.breakpoint.mdAndUp ? '' : 'padding: 0 !important;'"
    class="py-4 px-2 toolbar-content-padding-y-none"
    :class="{ 'border-bottom': !hasBg, 'border-bottom-dark': hasBg }"
    flat
  >
    <v-row>
      <v-col cols="1" sm="1" class="px-0">
        <v-btn
          elevation="0"
          :ripple="false"
          :height="43"
          class="
            font-weight-600
            text-capitalize
            drawer-toggler
            rounded-sm
          "
          :class="{
            'btn-dark-toggler-hover': !hasBg,
            'btn-toggler-hover': hasBg,
            active: togglerActive,
          }"
          v-if="$vuetify.breakpoint.mobile"
          color="transparent"
          style="justify-content: left;"
          @click="drawerClose"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
            <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
            <i class="drawer-toggler-line" :class="{ 'bg-white': hasBg }"></i>
          </div>
        </v-btn>
      </v-col>

      <v-col cols="5" sm="5">
        <router-link
          :to="ruolo === 'Amministratore' ? '/' : '/listProgettiOperatore'"
        >
          <v-img 
            src="@/assets/logo.svg" 
            :width="$vuetify.breakpoint.mdAndUp ? '100px' : '80px'"
            :class="!$vuetify.breakpoint.mdAndUp ? 'mt-1' : ''"
          ></v-img>
        </router-link>
      </v-col>

      <v-col cols="6" sm="6" class="text-right">
        <v-btn
          depressed
          :ripple="false"
          @click="logout()"
          class="font-weight-600 ls-0 text-capitalize pe-0"
          color="transparent"
        >
          <v-icon class="mr-3">fas fa-user</v-icon>
          <span
            :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
            :style="!hasBg ? 'color: rgba(0,0,0, .6)' : ''"
            >{{ $vuetify.breakpoint.smAndUp ? nomeLogin : '' }}</span
          >
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import apiUtenti from "@/js/pages/utenti";
import { generalFunction } from "@/js/generalFunction.js";
export default {
  name: "app-bar",
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: Boolean,
  },
  data() {
    return {
      token: generalFunction.getToken(),
      drawer: false,
      togglerActive: false,
      dropdown1: [
        {
          title: "Notifica1",
          description: "Una notifica in cui potremmo metterci qualcosa",
        },
      ],
      nomeLogin: "",
    };
  },
  computed: {
    ruolo() {
      return this.$store.state.ruolo || "";
    }
  },
  methods: {
    drawerClose() {
      this.togglerActive = !this.togglerActive;
      this.$emit("drawer-toggle", true);
    },
    async loadData() {
      this.token = generalFunction.getToken();
      if(this.token) {
        let utente = await apiUtenti.getUtenteFromToken(await this.token);
        this.nomeLogin = utente["nome"]; 
      } else this.nomeLogin = '';
    },
    async logout(){
      if(
        this.$cookies.get('token_goldencar') && 
        confirm('Effettuare il logout?')
      ) {
        this.$cookies.remove('token_goldencar');
        this.$store.state.token = '';
        this.$store.state.ruolo = '';
        this.nomeLogin = '';
        this.$router.push('/login');
      }
    }
  },
  async created() {
    this.loadData();
    this.EventBus.$on("login", () => {
      this.loadData();
    });
  },
  watch: {
    toggleActive(val) {
      this.togglerActive = val;
    },
  },
};
</script>
